import styles from "./LoaderCard.module.scss";
import SpinLoader  from "./SpinLoader";

const LoaderCard = () => {

  return (
    <div className={styles.root}>  
      <SpinLoader/>
    </div>
  );
};

export default LoaderCard;
